import { getHolidays,postHolidays } from '../../../../api/eastCoastDataApi/setting/HolidaySettingApi'
import CONST from '../../../../utils/const'
import Utils from '../../../../utils/utils'

const state = {
  holidays : [],
  newHolidays:[],
  holidayMap: new Map()
}

const getters = {
  getHolidayMap: state => {
    return state.holidayMap
  },

  getHolidays: state => {
    return state.holidays
  },

}

const actions = {
  async getHolidays({ commit }) {
    const result = await getHolidays()
    if(result.success) {
      commit('holidays', result.data)
    }
  },

  async postHolidays({commit}, controlData ={}) {
    // async postHolidays(controlData ={}) {

    const result = await postHolidays(controlData)

    if(!Utils.isEmptyObject(result) && result.success) {
      commit('updateHolidays', { data: result.data, mode: 'post' })
    }
    return result
  }


}

const mutations = {
  holidays(state, data) {
    if(Utils.isEmptyObject(data)) {
      return
    }

    state.holidays = data

    const holidayMap = new Map();
    state.holidays.forEach(element => {
      holidayMap.set(element.date, true)
    })
    state.holidayMap = holidayMap
  },


  updateHolidays: (state, { data, mode }) => {
    switch(mode) {
      case 'post':
        //更新event資料
        state.newHolidays.push(data)
        break
    }
  }



}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
